// ============================================================================
// Allows custom controls to update quantity inputs
// ============================================================================
//
// ============================================================================


// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const FORM_INPUT_CONTAINER_SELECTOR = '.form__input-container';
const FORM_INPUT_SELECTOR           = '.form__input';
const CART_MESSAGE_ERROR            = '.cart__message--error';
const CART_ITEM_QUANTITY            = '.cart__item--quantity';
const MAX_REACHED_SELECTOR          = '.js-maxReached';

// Classes
const FORM_INCREMENT_UP_CLASS = 'form__increment--up';
const CART_ITEM_MAX_MESSAGE   = 'cart__item--quantity__max-qty-message';
const MAX_REACHED_CLASS       = 'js-maxReached';

// Events
const changeEvent = new Event('change');

const errorMessageElement = document.querySelector(CART_MESSAGE_ERROR);

class FormIncrement extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
    }

    handleClick(event) {
        this.handleQuantityChange(event.target, 'click');
    }

    handleKeydown(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.handleQuantityChange(event.target, 'keydown');
        }
    }

    handleQuantityChange(formIncrementButton, source) {
        const quantityInput = formIncrementButton.closest(FORM_INPUT_CONTAINER_SELECTOR).querySelector(FORM_INPUT_SELECTOR);

        this.updateQuantityInput(formIncrementButton, quantityInput);

        if (source === 'click') {
            quantityInput.focus();
        }
    }

    hideMaxError(element) {
        setTimeout(function () {
            if( element != null ) {
                element.textContent = '';
            }
        }, 4000);
    }


    updateQuantityInput(formIncrementButton, quantityInput) {
        const currentValue = quantityInput.value;
        const oldValue = formIncrementButton.parentElement.querySelector('input').value;
        let newValue;

        if (formIncrementButton.classList.contains(FORM_INCREMENT_UP_CLASS)) {
            if (oldValue < 5) {
                formIncrementButton.classList.remove('disabled');
                newValue = parseFloat(currentValue) + 1;
            } else {
                newValue = oldValue;
                formIncrementButton.classList.add('disabled');

                // Display Max Qty message on PDP
                if( errorMessageElement !== null ) {
                    errorMessageElement.textContent = window.translations.cartMaxQtyMessage;
                    this.hideMaxError(errorMessageElement);
                }

                // Display Max Qty message on Cart Page
                if( formIncrementButton.closest(CART_ITEM_QUANTITY) !== null ) {
                    const cartMaxQtyMessageElement = formIncrementButton.closest(CART_ITEM_QUANTITY).querySelector(MAX_REACHED_SELECTOR);

                    if ( cartMaxQtyMessageElement === null ) {
                        const node = document.createElement('p');
                        node.classList.add(CART_ITEM_MAX_MESSAGE, MAX_REACHED_CLASS);
                        const message = document.createTextNode(`${window.translations.cartMaxQtyMessage}`);
                        node.appendChild(message);

                        formIncrementButton.closest(CART_ITEM_QUANTITY).appendChild(node);

                        this.hideMaxError(cartMaxQtyMessageElement);
                    }
                }
            }

        } else {
            // Don't allow decrementing below 1
            if (currentValue > 1) {
                newValue = parseFloat(currentValue) - 1;
            } else {
                newValue = 1;
            }
        }

        quantityInput.value = newValue;
        quantityInput.dispatchEvent(changeEvent);
    }
}

customElements.define('form-increment', FormIncrement);
